import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import Select from "react-select";
import { CouponType, Select2Data } from "../../../utils/common";
import { getData } from "../../../utils/api";

library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { getData, IMG_URL } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
     control,
    getValues,
    watch,
  } = useForm();

  const imageFile = watch("image");

  // -------- Fetch existing data --------
  const GetEditData = async () => {
  const response = await getData(`/admin/masters/product-ratings/${id}`);

  if (response?.data) {
    const d = response.data;

    reset({
      ...d,
      product_id: {
        value: d?.Product?.id,
        label: d?.Product?.name,
      },
    });
  }
};


  useEffect(() => {
    GetEditData();
  }, []);



  const [products, setProducts] = useState([]);
  
      const getAllProducts = async () => {
      const response = await getData(`/common/masters/product`);
      if (response?.success) {
        setProducts(await Select2Data(response?.data, "product_id"));
      }
    };
    useEffect(() => {
      getAllProducts();
    }, []);


  // -------- Submit Updated Data --------
  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("product_id", data?.product_id?.value);
      finalData.append("growth_percentage", data?.growth_percentage);
      finalData.append("rating", data?.rating);
      finalData.append("total_review", data?.total_review);


      const response = await putData(`/admin/masters/product-ratings/${id}`, finalData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response?.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }

      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

    useEffect(() => {
  if (!products.length) return;

  if (watch("product_id") && typeof watch("product_id") === "number") {
    const selected = products.find(p => p.value === watch("product_id"));
    if (selected) {
      reset({
        ...getValues(),
        product_id: selected,
      });
    }
  }
}, [products]);

 return (
    <>
      <Modal {...props} onHide={props.handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Product Rating</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>

            <Row>

              {/* NAME */}
            <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Product</Form.Label>
                    </div>
                    <InputGroup>

                      <Controller
                        name="product_id" // name of the field
                        rules={{ required: "Select Product" }}
                        control={control}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.product_id
                                  ? "red"
                                  : baseStyles,
                              }),
                            }}
                            {...field}
                            value={field.value}
                            options={products}
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.product_id && (
                      <span className="text-danger">
                        {errors.product_id.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

             
              
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Total Review</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Enter Total Review"
                        className={classNames({
                          "is-invalid": errors?.total_review,
                        })}
                        {...register("total_review", {
                          maxLength: { value: 200, message: "Max 200 chars allowed" },
                        })}
                      />
                    </InputGroup>
                    {errors.total_review && (
                      <span className="text-danger">
                        {errors.total_review.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>



              {/* RATING */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Rating (1 - 5)</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="Enter rating"
                        className={classNames({
                          "is-invalid": errors?.rating,
                        })}
                        {...register("rating", {
                          required: "Rating is required",
                          valueAsNumber: true,
                          min: { value: 1, message: "Minimum rating is 1" },
                          max: { value: 5, message: "Maximum rating is 5" },
                        })}
                      />
                    </InputGroup>
                    {errors.rating && (
                      <span className="text-danger">
                        {errors.rating.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

               <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Growth Percentage</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Enter Total Review"
                        className={classNames({
                          "is-invalid": errors?.growth_percentage,
                        })}
                        {...register("growth_percentage", {
                          maxLength: { value: 200, message: "Max 200 chars allowed" },
                        })}
                      />
                    </InputGroup>
                    {errors.growth_percentage && (
                      <span className="text-danger">
                        {errors.growth_percentage.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>


            

            
              {/* BUTTONS */}
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>

            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;